export const ItemListStyles = {
  container: {
    padding: "24px 80px",
  },
};
